import * as R from 'ramda'
import { SET_ENTITIES } from 'actions'

const connectwiseReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_ENTITIES: {
      return R.merge(state, action.entities.connectwise)
    }
    default:
      return state
  }
}

export default connectwiseReducer



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/data/connectwise.js